module.exports = __webpack_public_path__ + "img/onboarding-icon-lighting.72ced470.svg";